import { useSelector } from 'react-redux';
import { getCountriesList } from '../modules/selectors/countries';
import { ICountry } from '../modules/types';

export function useCountry(countryId: string): ICountry | undefined {
  const countriesList = useSelector(getCountriesList);
  const country = countriesList.find((c) => c.id === countryId);

  return country;
}
